import { createInstance, ReactSDKClient } from '@optimizely/react-sdk';
import { Config } from '~/adapters/config/config';
import { useMemo } from 'react';
import { AccountsOptimizely } from '~/adapters/optimizely/accounts';

export enum OptimizelyProject {
    accounts = 'Accounts',
    fullstack = 'Fullstack',
    groups = 'Groups',
    stores = 'Stores',
}

export const SdkKeyMapper: Record<OptimizelyProject, string> = {
    [OptimizelyProject.accounts]: Config.ACCOUNTS_OPTIMIZELY_SDK_ACCOUNTS,
    [OptimizelyProject.fullstack]: Config.ACCOUNTS_OPTIMIZELY_SDK_FULLSTACK,
    [OptimizelyProject.groups]: Config.ACCOUNTS_OPTIMIZELY_SDK_GROUPS,
    [OptimizelyProject.stores]: Config.ACCOUNTS_OPTIMIZELY_SDK_STORES,
};

export const useOptimizelyProject = (projectName: OptimizelyProject | string): ReactSDKClient => {
    if (!Object.values(OptimizelyProject).includes(projectName as OptimizelyProject)) {
        throw new Error(`${projectName} is not a valid project name`);
    }

    const optimizely = useMemo(() => {
        // For Acounts project, we want to use global AccountsOptimizely instance
        if (projectName === OptimizelyProject.accounts) {
            return null;
        }

        return createInstance({
            sdkKey: SdkKeyMapper[projectName as OptimizelyProject],
            datafileOptions: {
                updateInterval: 300000, // in ms, 300000 is optimizely default
                autoUpdate: true,
            },
        });
    }, [projectName]);

    return optimizely || AccountsOptimizely;
};
